import React from 'react';
import "../style/switch-toggle.scss"

const SwitchToggle = ({ isOn, handleToggle, onColor}) => {
  return (
    <div className="bg-toggle">
      <div className="toggleText">
       <span className="toggle-cases">CASES</span>
      <input
        checked={isOn}
        onChange={handleToggle}
        className="react-switch-checkbox"
        id={`react-switch-new`}
        type="checkbox"
      />
      <label
        style={{ background: isOn && onColor }}
        className="react-switch-label"
        htmlFor={`react-switch-new`}
      >
        <span className={`react-switch-button`} />
      </label>
      <span className="toggle-deaths">DEATHS</span>
      </div>
    </div>
  );
};

export default SwitchToggle;